import React, {FC} from 'react';
import {provider, useInstance} from 'react-ioc';
import {BrowserRouter as Router, Navigate, Route, Routes,} from 'react-router-dom';
import {YMInitializer} from 'react-yandex-metrika';
import {ApolloClient, ApolloProvider} from '@apollo/client';
import {ConfigProvider, theme} from 'antd';
import ru_RU from 'antd/locale/ru_RU';
import {observer} from 'mobx-react-lite';

import 'dayjs/locale/ru';

import {GetMe} from '../components/common/GetMe/GetMe';
import ScrollToTop from '../components/common/ScrollToTop';
import {
    APPLICATION,
    AVATAR,
    CODE, DELETE_ACCOUNT, DOWNLOAD,
    INDEX, LOGIN, MULTI_FORM, POLICY, PROFILE, SPLASH, STORY, VIEWER_FILE, VIEWER_TEXT, WRITE,
} from '../config/routes';
import ApolloClientDI from '../model/graphql/ApolloClientDI';
import {Store} from '../model/store/Store';
import StoreDI from '../model/store/StoreDI';
import {Application} from '../pages/Application/Application';
import {Activate} from '../pages/Auth/Activate';
import {Avatar} from '../pages/Auth/Avatar';
import {Code} from '../pages/Auth/Code';
import {Login} from '../pages/Auth/Login';
import { Profile } from '../pages/Auth/Profile';
import {Download} from '../pages/Download/Download';
import {Index} from '../pages/Index/Index';
import {MultiForm} from '../pages/Index/Widgets/MultiForm';
import {DeleteAccount} from '../pages/Policy/DeleteAccount';
import {Policy} from '../pages/Policy/Policy';
import {Splash} from '../pages/Splash/Splash';
import {Story} from '../pages/Story/Story';
import {ViewerFile} from '../pages/Story/ViewerFile';
import {ViewerText} from '../pages/Story/ViewerText';
import {Write} from '../pages/Story/Write';
import {Metrika} from '../shared/helpers/Metrika';

import './App.scss';

const App: FC = () => {

    const apolloClient = useInstance(ApolloClient);
    const {hydrated, auth} = useInstance(Store)

    if (!hydrated) {
        return (
            <div>Loading...</div>
        );
    }

    return (
        <ConfigProvider locale={ru_RU} theme={{
            token: {
                colorPrimary: '#02E09D',
                colorText: '#000000',
                colorLink: '#02E09D',
                fontFamily: '\'Arial\', sans-serif',
                fontSize: 16,
                controlHeight: 40,
            },
            algorithm: theme.defaultAlgorithm

        }}>
            <ApolloProvider client={apolloClient}>
                <Router>
                    <ScrollToTop/>
                    <YMInitializer accounts={[106775916]}/>
                    <Metrika/>

                    {/*без авторизации*/}
                    {!auth.hasAuthToken &&
                        <Routes>
                            <Route path={SPLASH} element={<Splash/>}/>
                            <Route path={POLICY} element={<Policy/>}/>
                            <Route path={DELETE_ACCOUNT} element={<DeleteAccount/>}/>
                            <Route path={DOWNLOAD} element={<Download/>}/>
                            <Route path={LOGIN} element={<Login/>}/>
                            <Route path={CODE} element={<Code/>}/>
                            <Route path="*" element={<Navigate to={SPLASH}/>}/>
                        </Routes>
                    }

                    {/*С авторизацией*/}
                    {auth.hasAuthToken &&
                        <>
                            <GetMe/>

                            {/*Без анкеты*/}
                            {!auth.hasAnketData &&
                                <Routes>
                                    <Route path="*" element={<Profile/>}/>
                                </Routes>
                            }

                            {/*С анкетой не оплачен*/}
                            {auth.hasAnketData && !auth.paid &&
                                <Routes>
                                    <Route path="*" element={<Activate/>}/>
                                </Routes>
                            }

                            {/*С анкетой оплачен*/}
                            {auth.hasAnketData && auth.paid &&
                                <Routes>
                                    <Route path={INDEX} element={<Index/>}/>
                                    <Route path={PROFILE} element={<Profile/>}/>
                                    <Route path={APPLICATION} element={<Application/>}/>
                                    <Route path={AVATAR} element={<Avatar/>}/>
                                    <Route path={MULTI_FORM} element={<MultiForm/>}/>
                                    <Route path={STORY} element={<Story/>}/>
                                    <Route path={WRITE} element={<Write/>}/>
                                    <Route path={VIEWER_FILE} element={<ViewerFile/>}/>
                                    <Route path={VIEWER_TEXT} element={<ViewerText/>}/>
                                    <Route path={POLICY} element={<Policy/>}/>
                                    <Route path={DELETE_ACCOUNT} element={<DeleteAccount/>}/>
                                    <Route path={DOWNLOAD} element={<Download/>}/>
                                    <Route path="*" element={<Navigate to={INDEX}/>}/>
                                </Routes>
                            }

                        </>
                    }


                </Router>
            </ApolloProvider>
        </ConfigProvider>
    );
};

export default provider(
    StoreDI(),
    ApolloClientDI(),
)(observer(App));
